import styled from "astroturf/react";



export const AppContainer = styled("div")`
  display: flex;
  min-height: 100vh;
  flex-direction: column;
`;
